import { render, staticRenderFns } from "./copy1.vue?vue&type=template&id=3245b0f6&scoped=true"
import script from "./copy1.vue?vue&type=script&lang=js"
export * from "./copy1.vue?vue&type=script&lang=js"
import style0 from "./copy1.vue?vue&type=style&index=0&id=3245b0f6&prod&lang=stylus&scoped=true"
import style1 from "./copy1.vue?vue&type=style&index=1&id=3245b0f6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245b0f6",
  null
  
)

export default component.exports